import { Auditable, QueryParams, SortParams } from "..";

export interface AuditLogCategory extends Auditable {
    name: string;
    tenantId: number;
}

export const DefaultAuditLogCategoryQueryParams: QueryParams = {
    name: "",
};

export const DefaultAuditLogCategorySortParams: SortParams = {
    orderBy: "name",
    orderDesc: "false",
};
